import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Post' },
    { value: 2, label: 'Community Notice' },
    { value: 3, label: 'Staff Notice' },
    { value: 4, label: 'Global Notice' },
    { value: 5, label: 'Text' },
    { value: 6, label: 'Student Notice' },
    { value: 7, label: 'Attendance Note' },
  ],
});
